import { useCallback } from 'react';
import _ from 'underscore';
import { useLocation } from 'react-router-dom';

import { WAITING_MESSAGE_TYPES, WAITING_MESSAGE_DISABLE_ALL } from './constants';

export const useGetWelcomeWaitingMessageTypes = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const disableMessageSubscriptions = searchParams.get('disableMessageSubscriptions');

    return useCallback(({ excludeWaitingMessages = '' } = {}) => {
        if (disableMessageSubscriptions === 'all') {
            return WAITING_MESSAGE_DISABLE_ALL;
        }

        const decodedDisableMessageSubscriptions = decodeURIComponent(`${disableMessageSubscriptions},${excludeWaitingMessages}`);

        return _.difference(WAITING_MESSAGE_TYPES.split(',') || [], decodedDisableMessageSubscriptions.split(',')).join(',');
    }, [disableMessageSubscriptions]);
};
